import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Icon, Link, Show, useBoolean } from "@chakra-ui/react"
import Supply from "../pages/Supply";
import { TbLayoutSidebarRightCollapse, TbLayoutSidebarRightExpand } from "react-icons/tb";

type SupplyDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  id: string;
}

function SupplyDrawer({isOpen, onClose, id}: SupplyDrawerProps) {

  const [drawerExpand, setDrawerExpand] = useBoolean(false);
  const drawerExpandIcon = (drawerExpand) ? TbLayoutSidebarRightCollapse : TbLayoutSidebarRightExpand;
  const drawerSize = (drawerExpand) ? "95%" : "50%";

  return (
    <Drawer onClose={onClose} isOpen={isOpen} size={'xl'}>
      <DrawerOverlay />
      <DrawerContent maxW={{ base: "90%", lg: drawerSize }}>
        <DrawerCloseButton />
        <DrawerHeader backgroundColor={"purple.100"} color={"white"} >
          <Link onClick={setDrawerExpand.toggle}><Show above='lg'><Icon as={drawerExpandIcon}/></Show></Link> Supply
        </DrawerHeader>
        <DrawerBody backgroundColor={"purple.10"}>
          <Supply id={id}></Supply>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  )
}

export default SupplyDrawer